import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';

export function useBulkConfig() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (body: Record<string, unknown>) =>
      pb.send('/api/config/bulk-update', { method: 'POST', body }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['config'] });
      toast('Configuración guardada', 'success');
    },
    onError: () => toast('Error al guardar configuración', 'error'),
  });
}
